import React from "react";
import { Text, View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";
import { GameLeaderboardDataReturn } from "@freeplay/shared-code";
export interface LeaderboardEntryProps {
    lbData?: GameLeaderboardDataReturn;
    place: number;
    loggedInPlayerRow: boolean;
}

export const LeaderboardEntry: React.FC<LeaderboardEntryProps> = ({ lbData, place, loggedInPlayerRow }) => {
    const placeDisplay = place;
    let nameDisplay = "Freeplay User";
    let scoreDisplay = 51;
    const styles = useDynamicStyles(generateStyles);

    if (lbData) {
        // display names arent set atm, use that when it's there
        if (lbData.displayName) nameDisplay = lbData.displayName;
        scoreDisplay = lbData.score;
    }

    return (
        <View style={[styles.container]}>
            <View style={[styles.placeContainer, loggedInPlayerRow && styles.backgroundHighlight]}>
                <Text style={[styles.place, loggedInPlayerRow && styles.containerHighlight]}>{placeDisplay}</Text>
            </View>
            <View style={[styles.infoContainer, loggedInPlayerRow && styles.infoContainerHighlight]}>
                <View style={[styles.infoInnerContainer, loggedInPlayerRow && styles.infoInnerContainerHighlight]}>
                    <Text style={styles.name}>{nameDisplay}</Text>
                    <Text style={styles.score}>{scoreDisplay}</Text>
                </View>
            </View>
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        container: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "center",
            marginTop: 10,
        },
        infoContainer: {
            height: 30,
            flexGrow: 1,
            marginLeft: 5,
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 2,
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_PLACE_BACKGROUND),
        },
        infoInnerContainer: {
            height: 26,
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            paddingHorizontal: 10,
            borderColor: "transparent",
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_PLACE_BACKGROUND),
        },
        infoContainerHighlight: {
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_MY_PLACE_TEXT),
        },
        infoInnerContainerHighlight: {
            borderColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
        },
        containerHighlight: {
            color: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_MY_PLACE_TEXT),
        },
        backgroundHighlight: {
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_MY_PLACE_TEXT),
        },
        placeContainer: {
            width: 30,
            height: 30,
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_PLACE_TEXT),
            justifyContent: "center",
            alignItems: "center",
        },
        place: {
            height: 26,
            width: 26,
            borderColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_PLACE_BACKGROUND),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            textAlign: "center",
            alignSelf: "center",
            color: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_PLACE_TEXT),
            fontSize: 12,
            fontWeight: "800",
            lineHeight: 22,
        },
        name: {
            flex: 1,
            fontSize: 14,
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
            fontWeight: "600",
        },
        score: {
            color: () => EStyleSheet.value(GlobalStyles.LEADERBOARD_SCORE_TEXT),
            textAlign: "right",
            fontSize: 14,
            fontWeight: "800",
        },
    });
};
